export default __webpack_public_path__ + "static/media/logo-white-min.62b78a41.svg";